/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setCashtagUrlEnabled} from '../api'

export const useMutationSetCashtagUrlEnabled = createReactQueryMutationHook('setCashtagUrlEnabled', setCashtagUrlEnabled)
